import React from 'react';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import '../../../node_modules/ag-grid/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid/dist/styles/ag-theme-material.css';
import 'layouts/material-admin/ag-grid-material.css';
import AgGridPaginationCtrl from './AgGridPaginationCtrl';
import Divider from 'material-ui/Divider';
import './styles/AgGridTableCtrlStyles.css';

import styles from './styles/AgGridTableCtrlStyles';
import DateTimeCellRender from './cellRenderers/DateTimeCellRender';
import AddressCellRender from './cellRenderers/AddressCellRender';
import DeviceCellRender from './cellRenderers/DeviceCellRender';
import MakeModelCelRender from './cellRenderers/MakeModelCelRender';
import LinkToDetailsCellRender from './cellRenderers/LinkToDetailsExpandedCellRender';


class AgGridTableCtrl extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.onGridReady = this.onGridReady.bind(this);
        this.getRowHeight = this.getRowHeight.bind(this);
        this.isFirstColumn = this.isFirstColumn.bind(this);
        this.onRowSelected = this.onRowSelected.bind(this);
        this.onSortChanged = this.onSortChanged.bind(this);
        this.isSelectedSort = this.isSelectedSort.bind(this);
        this.moveRowIndex = this.moveRowIndex.bind(this);

        this.state = {
            gridOptions: {
                enableSorting: true,
                enableServerSideSorting: true,
                sortingOrder: ["desc", "asc"],
                defaultColDef: {
                    // checkbox solo alla prima colonna
                    checkboxSelection: this.isFirstColumn,
                    minWidth: 200
                },
                rowSelection: "multiple",
                suppressCellSelection: true,
                suppressRowClickSelection: true,
                rowMultiSelectWithClick: true,
                enableRangeSelection: false,
                pagination: false,
                animateRows: true,
                components:{
                    'dateTimeCellRenderer': DateTimeCellRender,
                    'addressCellRender': AddressCellRender
                },
                onRowClicked: this.props.handleRowClicked
            },
            columnDefs: [
              {
                headerName: this.props.translate('GLOBAL.icnId'),
                field: "icn.id",
                // solo questa colonna ha la selectall
                headerCheckboxSelection: true,
                sort: this.isSelectedSort("icn.id"),
                autoHeight: true,
                minWidth: 170,
                headerClass: "headerStyle"
              },
              {
                headerName: this.props.translate('GLOBAL.device'),
                field: "icn.deviceId",
                sort: this.isSelectedSort("icn.deviceId"),
                //suppressSizeToFit: true,
                cellRendererFramework : DeviceCellRender,
                autoHeight: true,
                minWidth: 170,
                headerClass: "headerStyle"
              },
              {
                headerName: this.props.translate('GLOBAL.vin'),
                field: "icn.vin",
                sort: this.isSelectedSort("icn.vin"),
                autoHeight: true,
                minWidth: 200,
                headerClass: "headerStyle"
              },
              {
                headerName: this.props.translate('GLOBAL.licenseNumber'),
                field: "icn.licenseNumber",
                autoHeight: true,
                minWidth: 150,
                headerClass: "headerStyle"
              },
              {
                headerName: this.props.translate('GLOBAL.make'),
                field: "icn.make",
                cellRendererFramework : MakeModelCelRender,
                autoHeight: true,
                minWidth: 250,
                headerClass: "headerStyle"
              },
              {
                headerName: this.props.translate('GLOBAL.crashSeverity'),
                field: "icn.severityCode",
                sort: this.isSelectedSort("icn.severityCode"),
                autoHeight: true,
                minWidth: 150,
                headerClass: "headerStyle"
              },
              {
                headerName: this.props.translate('GLOBAL.eventClassification'),
                field: "icn.eventClassification",
                sort: this.isSelectedSort("icn.eventClassification"),
                autoHeight: true,
                minWidth: 150,
                headerClass: "headerStyle"
              },
              {
                headerName: this.props.translate('GLOBAL.crashDateTime'),
                field: "icn.crashDate",
                sort: this.isSelectedSort("icn.crashDate"),
                //suppressSizeToFit: true,
                cellRenderer: 'dateTimeCellRenderer',
                cellRendererParams: {
                    fields: {currentLanguage: props.currentLanguage}
                },
                autoHeight: true,
                minWidth: 150,
                headerClass: "headerStyle cellWrapText"
              },
              {
                headerName: this.props.translate('GLOBAL.address'),
                field: "icn.address",
                width: 200,
                headerClass: "headerStyle",
                suppressSorting: true,
                autoHeight: true,
                cellStyle: { "white-space": "normal", "word-break":"normal", "line-height": "20px"}
              },
              {
                headerName: "",
                field: "icn",
                width: 100,
                suppressSorting: true,
                cellRendererFramework : LinkToDetailsCellRender,
                //suppressSizeToFit: true,
                cellRendererParams: {
                    fields: {
                        linkGoToDetails: props.linkGoToDetails,
                        showSingleExport: props.showSingleExport,
                        isIcnPlus: props.isIcnPlus,
                        isDent: props.isDent
                    }
                }
              }

            ],
            rowData: this.props.searchResults
          };

    }

    isSelectedSort(columnName){
        if(!columnName) return null;

        if(!this.props.sortName) return null;

        var sortName = columnName.replace("icn.", "");

        if(this.props.sortName !== sortName)
        {
            return null;
        }

        return this.props.isDescending ? "desc" : "asc";
    }

    /**
     * click su sort
     * @param {} event
     */
    onSortChanged(event){
        var sortModel = event.api.getSortModel();
        if(!sortModel) return;
        if(sortModel.length <= 0) return;
        this.props.handleSortChanged(sortModel[0].colId, sortModel[0].sort === "desc")
    }

    onRowSelected(event) {
        this.props.handleSelectedRows(event.data.icn.id);
    }

    isFirstColumn(params) {
        if(!params.columnApi) return false;
        var displayedColumns = params.columnApi.getAllDisplayedColumns();
        var thisIsFirstColumn = displayedColumns[0] === params.column;
        return thisIsFirstColumn;
    }

    getRowHeight(params) {
        return 21  * (Math.floor(params.data.icn.address.length / 20) + 1);
    }

    moveRowIndex(){
        console.info("moving rowindex to " + this.props.rowIndex );
        this.gridApi.ensureIndexVisible(this.props.rowIndex, 'top');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        if(this.props.isSelectedAll === true)
        {
            this.gridApi.selectAll();
        }

        this.columnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();

        params.api.resetRowHeights();

        if(this.props.rowIndex && this.props.rowIndex > 0)
        {
            setTimeout( this.moveRowIndex, 100);
        }

    }

    render() {
        return(
            <div style={styles.mainContainer}>
                <div style={styles.gridContainer}  className="ag-theme-material" >
                    <AgGridReact
                        gridOptions={this.state.gridOptions}
                        columnDefs={this.state.columnDefs}
                        onSortChanged={this.onSortChanged}
                        rowData={this.state.rowData}
                        defaultColDef={this.state.defaultColDef}
                        getRowHeight={this.getRowHeight}
                        onGridReady={this.onGridReady}
                        onRowSelected={this.onRowSelected}
                    />
                </div>
                <Divider />
                <AgGridPaginationCtrl
                    selectedPageSize={this.props.selectedPageSize}
                    pageSizeList={this.props.pageSizeList}
                    currentPage={this.props.currentPage}
                    totalCount={this.props.totalCount}
                    handlePagination={this.props.handlePagination}
                    handlePageSizeChanged={this.props.handlePageSizeChanged}
                    translate={this.props.translate}
                    />
            </div>
        );
    }
}

AgGridTableCtrl.propTypes = {
    translate: PropTypes.func.isRequired,
    searchResults: PropTypes.array.isRequired
};

export default AgGridTableCtrl;



// WEBPACK FOOTER //
// ./src/components/table/AgGridTableCtrl.js